import { ComponentProps } from 'react';
import { useLocation } from 'react-router-dom';

import {
  ButtonColors,
  ButtonSizes,
  ButtonVariants,
  LinkButton,
} from 'components';
import { Icon, Typography } from '@repo/ui';
import styles from './NextStep.module.css';

export const CheckIcon = ({
  isCompleted,
  isBlocked,
  color,
  filled = false,
  size = 'm',
}: {
  isCompleted: boolean;
  isBlocked?: boolean;
  color?: ComponentProps<typeof Icon>['color'];
  filled?: boolean;
  size?: ComponentProps<typeof Icon>['size'];
}) => {
  if (isBlocked)
    return (
      <div className={styles.blockedIcon}>
        <Icon name='alertTriangleFilled' size={size} color='red' />
      </div>
    );
  if (isCompleted && filled)
    return <Icon name='checkFilled' size={size} color={color ?? 'purple-300'} />;
  return isCompleted ? (
    <div className={styles.completedIcon}>
      <Icon name='check' size={size} color={color ?? 'purple-300'} />
    </div>
  ) : (
    <div className='purple-icon flex align-items-center'>
      <Icon name='circle' size={size} />
    </div>
  );
};

type NextStepProps = {
  title: string;
  isActive: boolean;
  isCompleted: boolean;
  linkCompleted?: string;
  linkEdit?: string;
  children: React.ReactNode;
};
export const NextStep = ({
  isActive,
  isCompleted,
  linkCompleted,
  linkEdit,
  title,
  children,
}: NextStepProps) => {
  const { pathname } = useLocation();
  return (
    <div className={styles.nextStep}>
      <div className='flex align-items-center justify-content-between gap-2'>
        <div className='flex align-items-center gap-2'>
          <Typography variant='body-s'>{title}</Typography>
          {isCompleted && !!linkCompleted && (
            <LinkButton
              label='View'
              href={linkCompleted}
              state={{ from: pathname }}
              variant={ButtonVariants.TEXT}
              size={ButtonSizes.M}
              color={ButtonColors.PURPLE}
            />
          )}
          {isCompleted && !!linkEdit && (
            <LinkButton
              label='Edit'
              href={linkEdit}
              state={{ from: pathname }}
              variant={ButtonVariants.TEXT}
              size={ButtonSizes.M}
              color={ButtonColors.PURPLE}
            />
          )}
        </div>
        <CheckIcon isCompleted={isCompleted} />
      </div>
      {isActive && <div className={styles.content}>{children}</div>}
    </div>
  );
};
